import { updatesData } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center">
            最新动态
          </h2>
          <p className="mt-2 text-sm text-foreground-500 text-center">
            平台更新与影视快讯，随时掌握新鲜事
          </p>
          <div className="mt-8 relative">
            <div className="absolute left-[19px] top-0 bottom-0 w-px bg-background-200 hidden sm:block"></div>
            <div className="space-y-5">
              {updatesData.map((item) => (
                <div key={item.id} className="flex gap-4 items-start">
                  <div className="hidden sm:flex w-10 h-10 flex-shrink-0 rounded-full bg-background-50 border-2 border-primary-200 items-center justify-center relative z-10">
                    <div className="w-2 h-2 rounded-full bg-primary-500"></div>
                  </div>
                  <div className="flex-1 min-w-0 bg-background-50 rounded-xl border border-background-200/70 p-4">
                    <div className="flex flex-wrap items-center gap-2 mb-1">
                      <span className="text-xs font-label text-foreground-400">{item.date}</span>
                      <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${item.tagColor}`}>
                        {item.tag}
                      </span>
                    </div>
                    <p className="text-sm font-medium text-foreground-800">{item.title}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}